import * as ROUTES from '../common/routes';
import ImageContainer from './ImageContainer';
import React, { useEffect, useRef } from 'react';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { fetchData } from '../common/app/actions';
import { getText } from '../common/utils/helpers';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import Share from './Share';
import { useTranslations } from '../common/hooks/useTranslations';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      articleContainerStyle: {
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-start',
        boxSizing: 'border-box',
        padding: '40px 50px',
      },
      textContainerStyle: {
        width: '50%',
        paddingRight: '30px',
        display: 'flex',
        flexDirection: 'column',
      },
      titleStyle: {
        fontWeight: FONT_WEIGHT.medium,
        fontSize: '30px',
        lineHeight: '36px',
        fontFamily: FONTS.garamond,
        color: COLORS.appBlue,
        marginBottom: '16px',
        textTransform: 'uppercase',
      },
      textStyle: {
        fontWeight: FONT_WEIGHT.medium,
        fontSize: '20px',
        lineHeight: '26px',
        fontFamily: FONTS.alegreya,
        color: COLORS.textBlack,
        textAlign: 'justify',
        '& b': {
          fontWeight: FONT_WEIGHT.semiBold,
        },
        '& i': {
          fontStyle: 'italic',
        },
      },
      imageContainerStyle: {
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
      },
      shareStyle: {
        margin: '20px 0',
      },
      [`@media (max-width: 840px)`]: {
        articleContainerStyle: {
          flexDirection: 'column-reverse',
        },
        textContainerStyle: {
          width: '100%',
        },
        imageContainerStyle: {
          width: '100%',
        },
      },
      [`@media (max-width: 600px)`]: {
        articleContainerStyle: {
          padding: '20px',
        },
      },
      [`@media (max-width: 400px)`]: {
        textStyle: {
          textAlign: 'left',
        },
      },
    })
);

const Article = ({ type }): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const data = useSelector((state: any) => state.app.appData);
  const lng = useSelector((state: any) => state.app.lng);

  const currentData = data.find((item) => item.content.uid === type);

  const shareText = useTranslations('share_text');

  const title: string = getText(currentData?.content, 'title', lng);
  const rawText: string = getText(currentData?.content, 'text', lng);
  const text: string = rawText.replace(/(?:\r\n|\r|\n)/g, '<br>');

  const hasImages = Boolean(currentData.images?.length);

  return (
    <div className={classes.articleContainerStyle}>
      <div className={classes.textContainerStyle}>
        <div className={classes.titleStyle}>{title}</div>
        <div
          className={classes.textStyle}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
      <div className={classes.imageContainerStyle}>
        {hasImages && <ImageContainer data={currentData} />}

        <div className={classes.shareStyle}>
          <Share
            title={`${title}.`}
            text={shareText || ''}
            url={window.location.href}
          />
        </div>
      </div>
    </div>
  );
};

export default Article;
